export const SunIcon = ({ className = "h-8 w-8 text-green cursor-pointer" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="1.75"
    >
      <circle cx="12" cy="12" r="4" />

      <line x1="12" y1="2" x2="12" y2="6" />
      <line x1="12" y1="18" x2="12" y2="22" />

      <line x1="2" y1="12" x2="6" y2="12" />
      <line x1="18" y1="12" x2="22" y2="12" />

      <line x1="4.2" y1="4.2" x2="6.8" y2="6.8" />
      <line x1="17.2" y1="17.2" x2="19.8" y2="19.8" />

      <line x1="4.2" y1="19.8" x2="6.8" y2="17.2" />
      <line x1="17.2" y1="6.8" x2="19.8" y2="4.2" />
    </svg>
  );
};

export const MoonIcon = ({ className = "h-8 w-8 text-green cursor-pointer" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="1.75"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M21 12.79A9 9 0 1111.21 3a7 7 0 0010 9.79z" />
    </svg>
  );
};
